// extracted by mini-css-extract-plugin
module.exports = {"montroseBlue":"#0072c7","fadedMontroseBlue":"rgba(0,114,199,.5)","montroseGreen":"#1fb53a","linkColor":"#0074d9"};